import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import Props from '../../utils/props.js';
import { GuestRatingContainer, GuestRatingHeader, GuestRatingGrade, GuestRatingScale, GuestRatingLabel, GuestRatingLinkContainer } from './style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import ArrowLink from '../Link/ArrowLink.js';

var _excluded = ["rating", "maxRating", "header", "text", "linkText", "linkAction", "subText", "beforeNumAnswers", "numAnswers", "afterNumAnswers", "seo", "responsive", "dontShowDecimal", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var GuestRating = function GuestRating(_ref) {
  var rating = _ref.rating,
    maxRating = _ref.maxRating,
    header = _ref.header,
    text = _ref.text,
    linkText = _ref.linkText,
    linkAction = _ref.linkAction,
    subText = _ref.subText,
    beforeNumAnswers = _ref.beforeNumAnswers,
    numAnswers = _ref.numAnswers,
    afterNumAnswers = _ref.afterNumAnswers,
    seo = _ref.seo,
    responsive = _ref.responsive,
    dontShowDecimal = _ref.dontShowDecimal,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (typeof rating !== 'number') {
    return false;
  }
  var displayRating = (Math.round(rating * 10) / 10).toString().replace('.', ',');
  if (displayRating.indexOf(',') < 0 && !dontShowDecimal) {
    displayRating += ',0';
  }
  var displayMaxRating = typeof maxRating === 'number' ? maxRating.toString().replace('.', ',') : '5';
  var renderType = linkAction ? 'a' : 'div';
  var guestRatingProps = Props(_objectSpread({
    itemProp: !!numAnswers && !!seo ? 'aggregateRating' : null,
    itemType: !!numAnswers && !!seo ? 'https://schema.org/AggregateRating' : null,
    itemScope: !!numAnswers && !!seo || null,
    onClick: linkAction,
    type: renderType === 'a' ? 'a' : null,
    as: renderType
  }, rest));
  return /*#__PURE__*/jsxs(GuestRatingContainer, _objectSpread(_objectSpread({
    className: className
  }, guestRatingProps), {}, {
    children: [header && /*#__PURE__*/jsx(GuestRatingHeader, {
      children: header
    }), /*#__PURE__*/jsx(GuestRatingGrade, {
      className: "sg-guest-rating__grade",
      responsive: responsive,
      itemProp: !!numAnswers && !!seo ? 'ratingValue' : null,
      children: displayRating
    }), /*#__PURE__*/jsxs(GuestRatingScale, {
      responsive: responsive,
      className: "sg-guest-rating__scale",
      children: ["/", /*#__PURE__*/jsx("span", {
        itemProp: !!numAnswers && !!seo ? 'bestRating' : null,
        children: displayMaxRating
      })]
    }), text && /*#__PURE__*/jsx(GuestRatingLabel, {
      responsive: responsive,
      children: text
    }), linkText && /*#__PURE__*/jsx(GuestRatingLinkContainer, {
      responsive: responsive,
      children: /*#__PURE__*/jsx(ArrowLink, {
        className: "sg-guest-rating__link",
        onClick: function onClick() {},
        children: linkText
      })
    }), (numAnswers || subText) && /*#__PURE__*/jsx(GuestRatingLabel, {
      responsive: responsive,
      className: "sg-guest-rating__label",
      children: !numAnswers ? subText : /*#__PURE__*/jsxs(Fragment, {
        children: [beforeNumAnswers, /*#__PURE__*/jsxs("span", {
          itemProp: !!numAnswers && !!seo ? 'ratingCount' : null,
          children: [numAnswers, ' ']
        }, "1"), afterNumAnswers && "".concat(afterNumAnswers.trim())]
      })
    })]
  }));
};
GuestRating.defaultProps = {
  maxRating: 5,
  header: null,
  text: null,
  responsive: false,
  linkText: null,
  linkAction: null,
  subText: null,
  className: null,
  beforeNumAnswers: null,
  numAnswers: null,
  afterNumAnswers: null,
  seo: false,
  dontShowDecimal: false
};
var GuestRating$1 = GuestRating;

export { GuestRating$1 as default };
//# sourceMappingURL=GuestRating.js.map
